import  { useContext } from "react";
import ScrollToTop from "../scroll";
import { IonLabel, IonToolbar, IonButton, IonButtons, IonPage, IonHeader, IonContent, IonCard, IonCardContent } from "@ionic/react";
import { ArrowBackSharp } from "@mui/icons-material";
import { useHistory } from "react-router";
import { Colour, FontType, Hindit } from "../global";

export default function Privacy() {
 let history = useHistory();
 const [clr,] = useContext(Colour);
 let color,colori, colorh;
 if(clr === "1") {
    color = "black";
    colori = ""
    colorh = "primary"
   }
   if(clr === "2") {
    color = "black";
    colori = "secondary"
    colorh = "warning"
   }
   if(clr === "3") {
    color = "black";
    colori = "secondary"
    colorh = "success"
   }
   if(clr === "4") {
    color = "black";
    colori = "secondary"
    colorh = "tertiary"
   }
   if(clr === "5") {
    color = "white";
    colori = "dark"
    colorh = "warning"
   }
   if(clr === "6") {
    color = "white";
    colori = "dark"
    colorh = "tertiary"
   }


 const [font,] = useContext(FontType);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 const [hindit,] = useContext(Hindit);

 return (
   <IonPage>
    <ScrollToTop />
    <IonHeader>
   <IonToolbar color={colorh}>
    <IonButtons slot="start" onClick={() => {
          history.push("/home");
    }}>
     <IonButton>
     <ArrowBackSharp style={{ fontSize: 30 }} />
     </IonButton>
    </IonButtons>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "प्राइवेसी पॉलिसी" : "Privacy Policy"}</IonLabel>
   </IonToolbar>
   </IonHeader>
   <IonContent color={colori} scrollEvents={true}>
   <div style={{ padding: "10px", textAlign: "justify", textJustify: "auto" }}>
    <IonCard color={colori} style={{ color: `${color}`, fontFamily: "Calibri, sans-serif"  }}>
        <IonCardContent>
   {hindit ? 
     <p style={{ fontFamily: `${fon}`, fontSize: "18px" }}>
     यह एप्लिकेशन किसी भी यूज़र डेटा का संग्रह नहीं करता है। इसके साथ ही, इस एप्लिकेशन से कोई डेटाबेस या बैकएंड नहीं जुड़ा है। यूज़र डेटा, जैसे की बुकमार्क्स और प्राथमिकताएँ, स्थानीय रूप में डिवाइस पर संचित होता है। यूज़र्स को अपने डेटा को Google ड्राइव पर बैकअप करने का विकल्प होता है, जहां यह एक निर्धारित फोल्डर में सुरक्षित रूप से संचित होता है, जो कि एप्लिकेशन के लिए विशेष है (यूज़र द्वारा पहुँच योग्य नहीं)। महत्वपूर्ण है कि इस एप्लिकेशन की क्षमता नहीं है कि वह Google ड्राइव में संचित यूज़र्स के व्यक्तिगत डेटा तक पहुंच या उसे बदल सके।
     </p>
    : 
    <p style={{  fontFamily: `${fon}`, fontSize: "18px" }}>
    This application does not collect any user data. Additionally, there is no database or backend connected to this application. All user data, such as bookmarks and preferences, is stored locally on the device. Users have the option to backup their data to Google Drive, where it is securely stored within a designated folder exclusive to the application (unreachable by the user). It is important to note that the application does not have the capability to access or alter personal data of the users stored in Google Drive.
     </p>
   }
   </IonCardContent>
   </IonCard>
     </div>
     <div style={{textAlign:"center"}}>
     <IonButton color={colorh} onClick={()=>{history.push("/home/terms")}}>
        {hindit ? "टर्म्स ऑफ़ सर्विस" : "Terms of Service"}
     </IonButton>
     </div>
   </IonContent>
   </IonPage>

 );
}
